<template>
  <page-layout class="gallery">

    <div class="title">
      <div class="title_top">
        <p>Gallery</p>
      </div>
    </div>

    <article class="inner">

			<div class="gallery_sch">
				<div class="sch_box">
					<input type="text" placeholder="Search Gallery" v-model="keyword" @keyup.enter="search"><a class="sch_btn" href="javascript:" @click="search()" >Search</a>
				</div>
				<a class="reset" href="javascript:" @click="reset()">Reset</a>
			</div>

      <div class="list_gallery series_results">
        <ul class="ctnr" v-for="(series, index) in getSeries" :key="series.idx">
          <div v-if="index > 0" v-show="index%5===0" class="ad_list">
            <display-container :section="811">
              <a slot-scope="{ component, row }">
                <img :src="component.getImage(row)">
              </a>
            </display-container>
          </div>
          <li @click="goSeries(series)">
          	<img v-if="isFileExist(series.poster_img)" :src="series.poster_img.url" class="fit_img"/>
          	<div class="subj">
          		<h5>{{series.title}}</h5>
          		<h6><b>{{series.album_cnt}}</b> Album<span v-if="series.album_cnt > 1">s</span></h6>
          	</div>
          </li>
        </ul>
      </div>

    </article>

  </page-layout>
</template>

<script>
	import Vue from 'vue'
  import { QDialog, Loading } from 'quasar'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import PageLayout from '../layouts/PageLayout'
  import { mapGetters } from 'vuex'
  export default {
    name: "Gallery",
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      QDialog,
      Loading,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | Gallery`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `Photo gallery from the tournament series`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', property: 'og:title', content: `Gallery | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `Photo gallery from the tournament series`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
        isOpenDialog: false,
        isModalInnerBox: true,
        selectedFeed: {},
        keyword: '',
      }
    },
    activated () {
      this.$store.dispatch('callSeries')
    },
    deactivated() {
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getSeries',
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      getRouteQueryIdx () {
        return this.$route.query.idx
      }
    },
		methods: {
      ...CommonMethods,
      goSeries (row) {
        this.$router.push(row.link_url)
      },
      search () {
        this.$router.replace('/gallery/search/' + this.keyword)
        this.keyword = ''
      },
      reset () {
        this.$router.replace('/gallery')
        this.keyword = ''
      },
    }
  }
</script>

<style scoped>
  .gallery {
    position: relative;
    top: -40px;
  }
  .gallery .title {
    background: url(/statics/img/bg_sub_title.jpg) center no-repeat;
    background-size: cover;
    margin-bottom: 40px;
  }
  .title_top {
    position: relative;
    width: 1220px;
    height: 180px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  .title_top:before {
    content: "";
    display: inline-block;
    width: 54px;
    height: 54px;
    background: url(/statics/img/bi_white.png) center no-repeat;
    background-size: cover;
    margin-right: 15px;
  }
  .title_top p {
    font-family: 'Roboto Slab';
    font-size: 60px;
    font-weight: 900;
    color: #fff;
    line-height: 1.0em;
    text-transform: capitalize;
    z-index: 1;
  }
	.gallery_sch {
    position: relative;
		text-align: right;
		margin: 0 0 20px 0;
  }
  .gallery_sch .sch_box {
		display: inline-block;
    width: 290px;
    height: 40px;
		background: #f5f5f5;
		border: 1px solid #000;
  }
  .gallery_sch .sch_box input {
    width: 208px;
    height: 40px;
    padding: 0 12px;
    font-size: 15px;
    font-weight: 500;
    color: #008c03;
    border: 0;
  }
  .gallery_sch .sch_box input:disabled {
    background: #222 !important;
  }
  .gallery_sch .sch_box input::-webkit-input-placeholder {
    color: #bbb;
    font-weight: 500;
  }
  .gallery_sch .sch_box input:-moz-placeholder {
    color: #bbb;
  }
  .gallery_sch .sch_box input::-moz-placeholder {
    color: #bbb;
  }
  .gallery_sch .sch_box input:-ms-input-placeholder {
    color: #bbb;
  }
	.gallery_sch .sch_btn {
    display: inline-block;
    width: 80px;
    height: 38px;
    transition: all 0.2s;
		background: #000;
		font-size: 15px;
		font-weight: 500;
		color: #fff;
		padding: 8px 0;
		text-align: center;
  }
	.gallery_sch .reset {
    display: inline-block;
    width: 70px;
    height: 40px;
    transition: all 0.2s;
		font-size: 15px;
		font-weight: 500;
		color: #000;
		padding: 9px 0;
		text-align: center;
		border: 1px solid #999;
		margin-left: 5px;
  }
  .list_gallery ul {
    display: inline-block;
    margin: 0 5px 5px 0;
    width: calc((100% - 10px) / 3);
    height: 400px;
    cursor: pointer;
  }
  .list_gallery ul:nth-child(10n+1),
  .list_gallery ul:nth-child(10n+7) {
    width: calc((100% - 10px) / 3 * 2 + 5px);
  }
  .list_gallery ul:nth-child(10n+2),
  .list_gallery ul:nth-child(10n+7),
  .list_gallery ul:nth-child(5n) {
    margin-right: 0;
  }
  .list_gallery ul:nth-child(5n) {
    margin-bottom: 180px;
  }
  .list_gallery ul .ad_list {
		position: absolute;
    left: 50%;
    margin-top: -90px;
    transform: translate(-50%, -50%);
  }
  .list_gallery ul .ad_list /deep/ a img {
		width: 728px !important;
    height: 90px !important;
  }
/*
  .list_gallery li {
    position: relative;
    display: inline-block;
    margin: 0 5px 5px 0;
    width: calc((100% - 10px) / 3);
    height: 386px;
    cursor: pointer;
  }
  .list_gallery li:nth-child(10n+2),
  .list_gallery li:nth-child(10n+6) {
    width: calc((100% - 10px) / 3 * 2 + 5px);
  }
  .list_gallery li:nth-child(10n+2),
  .list_gallery li:nth-child(10n+7),
  .list_gallery li:nth-child(5n) {
    margin-right: 0;
  }
*/
  .list_gallery li {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .list_gallery li img {
    width: 100%;
    transition: .15s;
  }
  .list_gallery li:hover img {
    filter: brightness(120%);
  }
  .list_gallery li .subj {
    position: absolute;
		bottom: 0;
		display: block;
		width: 100%;
		background: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1.0) 80%);
		color: #fff;
		padding: 40px 30px 20px 30px;
		box-sizing: border-box;
  }
  .list_gallery li .subj h5 {
		font-size: 21px;
    font-weight: 500;
    letter-spacing: -0.02em;
  }
  .list_gallery li .subj h6 {
		font-size: 15px;
    font-weight: 300;
		color: #00ff64;
  }
  .list_gallery li .subj h6 b {
		font-weight: 600;
  }

  /deep/ .fr-video { display: block !important; position: relative !important; height: 0 !important; padding-bottom: 56.25% !important; }
  /deep/ .fr-video iframe { position: absolute !important; width: 100% !important; height: 100% !important; top:0; left: 0; }
  /deep/ [data-f-id="pbf"] {
    display: none;
  }
</style>
